// Copyright 2018-2021 evolution.land authors & contributors
// SPDX-License-Identifier: Apache-2.0

export const FETCH_ERROR = 'Unable to fetch data:';
